import styled from 'styled-components/macro';

const Wrapper = styled.div`
  display: block;
  width: 100%;
  font-size: 18px;
  line-height: 1.41;

  div[data-block]:not(:last-child) {
    margin-bottom: 15px;
  }
`;

export default Wrapper;
